import { useEffect, useState, useRef } from 'react'
import { useSelector } from 'react-redux'
import { getMerchantDetails, getUserData } from '@store/user/selectors'
import { stepperStatusChipDot } from '../../kyc/utils'
import { stepConfiguration } from '../../stepsConfig'
import { getStepFromStatus } from '../utils'

// Image imports
import blurryStep from '@library/images/icons/blurryStep.svg'
import activeStep from '@library/images/icons/currentStep.svg'
import doneStep from '@library/images/icons/doneStep.svg'
import { fetchUserDetails } from '@store/user'
import { useAppDispatch } from '@library/utilities/hooks'

const Stepper = ({ currentStep, setCurrentStep }) => {
    const merchant_details = useSelector(getMerchantDetails)
    const hasMounted = useRef(false)
    const dispatch = useAppDispatch()
    const userData = useSelector(getUserData)

    const initialSteps = [
        {
            id: 0,
            title: 'Step 1',
            description: 'Upload Documents',
            icon: null,
            active: false,
            status: null,
        },
        {
            id: 1,
            title: 'Step 2',
            description: 'Review and Submit',
            icon: null,
            active: false,
            status: null,
        },
        {
            id: 2,
            title: 'Step 3',
            description: 'Contact Point Verification',
            icon: null,
            active: false,
            status: null,
        },
    ]

    const [steps, setSteps] = useState(initialSteps)

    const isPanelClickable = (stepNumber) => {
        const current_onboarding_status = merchant_details?.onboarding_status?.kwik_checkout_app
        if (
            current_onboarding_status !== 'kyc_verification_failed' &&
            current_onboarding_status !== 'kyc_verification_pending' &&
            current_onboarding_status !== 'setup_completed' &&
            stepConfiguration[current_onboarding_status]?.id < 14
        ) {
            if (stepNumber === 0) {
                return 'header'
            } else if (stepNumber === 1) {
                return stepConfiguration[current_onboarding_status]?.id >= 10 ? 'header' : 'disabled'
            } else if (stepNumber === 2) {
                return stepConfiguration[current_onboarding_status]?.id >= 11 ? 'header' : 'disabled'
            }
        }
        return 'header'
    }

    const getRequiredIcon = (stepId) => {
        const step = steps.find((s) => s.id === stepId)
        if (step?.status === 'Completed') {
            return doneStep
        } else if (step?.active) {
            return activeStep
        } else {
            return blurryStep
        }
    }

    useEffect(() => {
        let updated = initialSteps.map((step) => {
            // let currentStatusWiseStepNumber = getStepFromStatus(merchant_details?.onboarding_status?.kwik_checkout_app)

            // if (step.id <= currentStatusWiseStepNumber) {
            //     return { ...step, status: 'Completed', active: false, icon: doneStep }
            // } else if (step.id === currentStatusWiseStepNumber) {
            //     return { ...step, status: 'Pending', active: true, icon: activeStep }
            // } else {
            //     return { ...step, status: 'Pending', active: false, icon: blurryStep }
            // }

            const onboarding_status = merchant_details?.onboarding_status?.kwik_checkout_app
            const currentStatusId = stepConfiguration[onboarding_status]?.id

            if (step?.id === 0) {
                if (currentStatusId >= 10) {
                    return { ...step, status: 'Completed', active: false, icon: doneStep }
                } else if (currentStatusId < 10) {
                    return { ...step, status: 'Pending', active: true, icon: activeStep }
                }
            } else if (step?.id === 1) {
                if (currentStatusId >= 11) {
                    return { ...step, status: 'Completed', active: false, icon: doneStep }
                } else if (currentStatusId < 11) {
                    return { ...step, status: 'Pending', active: true, icon: activeStep }
                }
            } else if (step?.id === 2) {
                if (currentStatusId >= 12) {
                    return { ...step, status: 'Completed', active: false, icon: doneStep }
                } else if (currentStatusId < 12) {
                    return { ...step, status: 'Pending', active: true, icon: activeStep }
                }
            }
        })

        setSteps(updated)
    }, [merchant_details?.onboarding_status?.kwik_checkout_app])

    useEffect(() => {
        if (hasMounted.current) {
            let updated = steps.map((step) => {
                if (step.id === currentStep) {
                    return { ...step, active: true, icon: activeStep }
                } else {
                    return {
                        ...step,
                        active: false,
                        icon: step.status === 'Completed' ? doneStep : blurryStep,
                    }
                }
            })

            setSteps(updated)
        } else {
            hasMounted.current = true
        }
    }, [currentStep])

    const handleClick = (stepId) => {
        if (
            currentStep === 0 &&
            sessionStorage.getItem('all_docs_uploaded') === 'false' &&
            userData?.merchantDetails?.onboarding_status?.kwik_checkout_app !== 'kyc_verification_pending' &&
            userData?.merchantDetails?.onboarding_status?.kwik_checkout_app !== 'kyc_completed'
        ) {
            return
        }

        if (isPanelClickable(stepId) === 'disabled') return

        let updated = steps.map((step) => {
            if (step.id === stepId) {
                return { ...step, active: true }
            } else {
                return { ...step, active: false }
            }
        })

        // if (stepId === 1) {
        //     // dispatch(fetchUserDetails())
        //     window.location.reload()
        // }

        setSteps(updated)
        if (setCurrentStep) {
            setCurrentStep(stepId)
        }

        localStorage.removeItem('kyc_failure_current_step')
    }

    return (
        <div style={{ height: 'max-content' }} className='bg-white rounded-2xl border border-solid border-[#E6EDF4]'>
            {steps.map((step, index) => (
                <div
                    key={step.id}
                    className='relative flex items-start p-4 cursor-pointer'
                    style={{
                        background: step.active
                            ? 'linear-gradient(90deg, rgba(230, 237, 244, 1) 0%, rgba(255, 255, 255, 1) 100%)'
                            : '#FFFFFF',
                        borderLeft: step.active ? '2px solid #004B8D' : 'none',
                        borderTopLeftRadius: step.id === 0 ? '16px' : 'none',
                        borderTopRightRadius: step.id === 0 ? '16px' : 'none',
                        borderBottomLeftRadius: step.id === 2 ? '16px' : 'none',
                        borderBottomRightRadius: step.id === 2 ? '16px' : 'none',
                    }}
                    onClick={() => handleClick(step.id)}
                >
                    <div>
                        <div className='mr-3 mb-1'>
                            <img src={getRequiredIcon(step.id)} alt='step indicator' />
                        </div>
                        {index < steps.length - 1 && (
                            <div
                                className='mr-3 h-8 w-0 text-center ml-1'
                                style={{ border: '1.6px solid rgba(0, 0, 0, 0.06)' }}
                            ></div>
                        )}
                    </div>
                    <div>
                        <div className='text-xs' style={{ color: 'rgba(0, 0, 0, 0.5)' }}>
                            Step {step.id + 1}
                        </div>
                        <div>
                            <div
                                className={`text-sm text-black ${step.active ? 'font-bold' : 'font-normal'} leading-6`}
                                style={{ color: 'black' }}
                            >
                                {step.description}
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default Stepper
